import { HTTP_CP_LoadSignInBranding_Response } from '@api-new/companyservice';
import { environment } from '@environments/environment';
import { SigninCompanyIdOrNetworkIdModel } from '@shared/store/auth/models/signin-company-id-or-network-id.model';

export const brandingToSignInCompanyIdOrNetworkIdAdapter = (
  branding: HTTP_CP_LoadSignInBranding_Response | null,
  signInLinkCompanyId: string | null,
): SigninCompanyIdOrNetworkIdModel => {
  if (environment.mobileApp?.isMobileApp) return { signInNetworkId: environment.mobileApp.signInNetworkId };

  // INTENTIONALLY -> signInLinkCompanyId has PRIORITY over branding?.signInCompanyId
  const signInCompanyId = signInLinkCompanyId || branding?.signInCompanyId;

  return signInCompanyId ? { signInCompanyId } : { signInNetworkId: branding?.signInNetworkId };
};
